import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = () => {
  const sentinelRef = useRef(null);
  const [isStickyConversionBar, setIsStickyConversionBar] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // CB should be sticky when the sentinel:
        // - is not in the viewport (it is not intersecting)
        // - is not over the top of the page
        const shouldSetStickyConversionBar = !entry.isIntersecting && entry.boundingClientRect.top > 0;
        setIsStickyConversionBar(shouldSetStickyConversionBar);
      },
      {
        root: null,
        threshold: 0.1,
      },
    );

    const sentinel = sentinelRef.current;

    if (sentinel) {
      observer.observe(sentinel);
    }

    return () => {
      if (sentinel) {
        observer.unobserve(sentinel);
      }
    };
  }, []);

  return { sentinelRef, isStickyConversionBar };
};
